/**
 * Created by jpilz on 2/13/17.
 */
"use strict";
import {context} from '../../objects/context.js';
import ko from 'knockout';

class headerModel {

    constructor(params) {
        // Profile
        this.componentName = ko.observable("header");
        this.context = context;
        this.context.paramObj(params);
        this.id = this.context.util.guid();
        this.visible = ko.observable(true);

        this.init(params);

    }


    init(params) {

        //boot.appLogin();
        this.context.loginStatusObj().staticParams = "Check";
        this.context.loginStatusObj.valueHasMutated();
        this.context.init();

    }

}

export default { viewModel: headerModel, template: require('!raw-loader!./header.html') };


// WEBPACK FOOTER //
// ./src/components/header/header.js